import OcuEntityValidationResult from 'app/admin/common/dto/OcuEntityValidationResult';
import nBossConnection from 'modules/base/service/nBossConnection';
import { objArrayToMap } from 'app/admin/common/util/CommonUtil';
import OptimizeUnitTaskEditDto from '../dto/OptimizeUnitTaskEditDto ';

class UnitOptimizerTaskEditService {
    constructor() {
        this.connection = nBossConnection.connection;
        this.PARENT_CONTROL = 'taskManagerControl';
        this.CONTROL = 'unitOptimizerTaskEditControl';
    }

    /**
     * @return {Promise<OptimizeUnitTaskEditDto>}
     */
    create() {
        return new Promise((resolve, reject) => {
            this.connection
                .get(`/${this.CONTROL}/create`)
                .then(response => resolve(new OptimizeUnitTaskEditDto().setup(response.data)))
                .catch(reject);
        });
    }

    /**
     * @param {string} type
     * @return {Promise<OptimizeUnitTaskEditDto>}
     */
    createByType(type) {
        return new Promise((resolve, reject) => {
            this.connection
                .get(`/${this.CONTROL}/create`)
                .then(response => resolve(new OptimizeUnitTaskEditDto().setup({ ...response.data, type })))
                .catch(reject);
        });
    }

    /**
     * @param {number} id
     * @return {Promise<OptimizeUnitTaskEditDto>}
     */
    getData(id) {
        return new Promise((resolve, reject) => {
            this.connection
                .post(`/${this.CONTROL}/getData`, {
                    id
                })
                .then(response => resolve(new OptimizeUnitTaskEditDto().setup(response.data)))
                .catch(reject);
        });
    }

    /**
     * @param {OptimizeUnitTaskEditDto} dto
     * @return {Promise<OcuEntityValidationResult>}
     */
    save(dto) {
        return new Promise((resolve, reject) => {
            this.connection
                .post(`/${this.CONTROL}/save`, { dto: { ...dto/*, stateInject: objArrayToMap(dto.stateInject, 'stateInjectName', 'statInjectValue')*/ } })
                .then(response => resolve(new OcuEntityValidationResult().setup(response.data)))
                .catch(reject);
        });
    }

    /**
     * @param {number} id
     * @param {OptimizeUnitTaskEditDto} dto
     * @return {Promise<OcuEntityValidationResult>}
     */
    update(id, dto) {
        return new Promise((resolve, reject) => {
            this.connection
                .post(`/${this.CONTROL}/update`, {
                    id,
                    dto: { ...dto, /*stateInject: objArrayToMap(dto.stateInject, 'stateInjectName', 'statInjectValue')*/ }
                })
                .then(response => resolve(new OcuEntityValidationResult().setup(response.data)))
                .catch(reject);
        });
    }
}

export default new UnitOptimizerTaskEditService();